/**
 * Routes dossier où la sidenav reste repliée et sans toggle (extraction, classification,
 * déclaration agentique — c'est un écran de saisie plein cadre comme les deux autres).
 */
export const DOCUMENTS_EDITOR_SIDENAV_PATH_RE =
  /^\/documents\/[^/]+\/(extraction|classification|declaration)\/?$/

const DOCUMENTS_STATIC_SEGMENTS = new Set(['list', 'exported', 'deleted'])

export function isDocumentsEditorSidenavPath(pathname: string): boolean {
  return DOCUMENTS_EDITOR_SIDENAV_PATH_RE.test(pathname)
}

export function isDocumentsBatchImportEntryPath(pathname: string): boolean {
  const match = pathname.match(/^\/documents\/([^/]+)\/?$/)
  if (!match) {
    return false
  }
  return !DOCUMENTS_STATIC_SEGMENTS.has(match[1])
}

export function isDocumentsReturnUrlPath(pathname: string): boolean {
  return (
    isDocumentsEditorSidenavPath(pathname) ||
    isDocumentsBatchImportEntryPath(pathname)
  )
}
